<ul class="list-group mb-3">
	<li class="list-group-item d-flex flex-column" *ngFor="let group of formArray.controls; let i = index"
		[formGroup]="group">
		<ng-container [ngTemplateOutlet]="templateRef" [ngTemplateOutletContext]="{$implicit: i}"/>
	</li>
</ul>
